<template>
	<div class="pages content">
		<section class="pages-md-cont">
			<z-input class="m-t-10" type="password" v-model="params.password" title="新密码" :maxlength = 20 isMust = true></z-input>
			<z-input class="m-t-10" type="password" v-model="params.password1" title="确认密码" :maxlength = 20 isMust = true></z-input>
			<div class="m-t-20 fx">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleModifyPwd">保存</a>
			</div>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'ModifyPwd',
		components: {
		},
		data() {
			return {
				params:{
					password:null,
					password1:null
				}
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleModifyPwd(){
				if(!this.params.password){
					return this.$warning('请输入新密码(灬°ω°灬)')
				}
				if(!this.params.password1){
					return this.$warning('请输入确认密码(灬°ω°灬)')
				}
				if(this.params.password != this.params.password1) {
					return this.$warning('两次密码不一致哟 ╮(・o・)╭')
				}
				if((this.params.password).length < 6 || this.params.password1.length < 6) {
					return this.$warning('为了您的账号安全,建议密码长度大于6位 ( ･´ω`･ )')
				}
				this.modifyPwd(this.params).then((data)=>{
					this.$success('修改成功')
					this.clearPwd()
				},(msg)=>{
					this.$errorMsg('保存失败')
				})
			},
			clearPwd(){
				this.params.password = null
				this.params.password1 = null
			},
			...mapActions(['modifyPwd']),
		},
		deactivated (){//页面切换出去
	    }
	}
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
.pages-md-cont{
	width: 400px;
}
</style>


// WEBPACK FOOTER //
// ModifyPwd.vue?3f7aefc2